export function revisionLabel(number: string): string {
  return `Rev ${number}`
}
